import { render, staticRenderFns } from "./home.vue?vue&type=template&id=183cb67a&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "./home.vue?vue&type=style&index=0&id=183cb67a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../production-parity-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183cb67a",
  null
  
)

export default component.exports